export function iframeLoadedWoocommerceVtex (isCorrect) {
  setTimeout(() => {
    window.parent.postMessage(
      {
        type: 'iframe-mounted',
        origin: 'pinflag-checkout-iframe',
        message: isCorrect
      },
      '*'
    )
  }, 1500)
}
